(function(){
  'use strict';
  var grid=document.querySelector('[data-cc-blog-grid]');
  var nav=document.querySelector('[data-cc-blog-pagination]');
  if(!grid||!nav||!window.fetch||!window.DOMParser)return;
  var next=nav.querySelector('[data-cc-blog-next]');
  var busy=false;
  nav.addEventListener('click',function(e){
    var link=e.target.closest('[data-cc-blog-next]');
    if(!link||busy)return;
    e.preventDefault();
    busy=true;link.setAttribute('aria-disabled','true');link.textContent='Loading…';
    var nextUrl=link.href;
    fetch(nextUrl,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('Request failed');return r.text();})
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var incoming=doc.querySelector('[data-cc-blog-grid]');
        if(!incoming||!incoming.children.length)throw new Error('No new posts');
        var count=incoming.children.length;
        var fragment=document.createDocumentFragment();
        Array.prototype.slice.call(incoming.children).forEach(function(n){
          var item=document.importNode(n,true);item.classList.add('aos-animate');
          fragment.appendChild(item);
        });
        grid.appendChild(fragment);
        var more=doc.querySelector('[data-cc-blog-next]');
        if(more){link.href=more.href;link.textContent='Show more posts';link.removeAttribute('aria-disabled');}
        else{nav.removeChild(link);}
        var status=nav.querySelector('[role="status"]');
        if(status)status.textContent=count+' more posts loaded.';
        busy=false;
      }).catch(function(){
        busy=false;link.href=nextUrl;link.textContent='Open next posts';link.removeAttribute('aria-disabled');
        var status=nav.querySelector('[role="status"]');
        if(status)status.textContent='Could not load more automatically. Use the link to open the next page.';
        // On second click, allow the browser to navigate normally, even if AJAX keeps failing.
        link.removeAttribute('data-cc-blog-next');
      });
  });
})();
